import { downloadXlsx } from '@/shared/utils/xlsxExport';

export interface BulkTransferRow {
  bankName?: string;
  bankCode?: string;
  depositAccountNumber?: string;
  transferAmount?: number;
  depositorName?: string;
  memo?: string;
}

export const BULK_TRANSFER_HEADER_MAP: Record<string, string> = {
  bankName: '은행명',
  bankCode: '은행코드',
  depositAccountNumber: '입금계좌번호',
  transferAmount: '이체금액',
  depositorName: '예금주명',
  memo: '메모',
};

export const exportBulkTransferXlsx = (
  rows: BulkTransferRow[],
  yearMonth: string,
) => {
  const mapped = rows.map((row) => ({
    bankName: row.bankName ?? '',
    bankCode: row.bankCode ?? '',
    depositAccountNumber: row.depositAccountNumber ?? '',
    transferAmount: row.transferAmount ?? 0,
    depositorName: row.depositorName ?? '',
    memo: row.memo ?? '',
  }));
  downloadXlsx(mapped, `정산정보_${yearMonth}`, BULK_TRANSFER_HEADER_MAP);
};
